export default __webpack_public_path__ + "static/media/body-work-unaccept.7edcdbd5.png";